module.exports = __webpack_public_path__ + "static/media/MuliBold.09c35029.eot";